// ControlCheckboxGroupFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import GroupModel    from 'GroupModel.js';
import ControlModel    from 'ControlModel.js';
import CheckboxControlView  from 'common-inputs/CheckboxControlView.js';
import GroupControlView  from 'common-visuals/GroupControlView.js';
import listService from "../service/ListService";
//import CheckboxGroupControlView  from 'common-inputs/CheckboxGroupControlView.js';


//=============================================================================
//
// Creates a checkbox group, given a factoryService parameter key and
// a layout position. The factory key defines the
// control appearance through its template..
//
// -Maty Rocha, February 23, 2016
//
//=============================================================================
class ControlCheckboxGroupFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;
        const height = attributes.height;
        const width = attributes.width;
        const groupTabIndex = attributes.tabIndex;

        attributes.silent = false;

        //var id1 = sequenceService.nextDomId();
        var id2 = sequenceService.nextDomId();
        var id3 = sequenceService.nextDomId();
        var groupId = sequenceService.nextDomId();

        // common attributes for checkboxes
        attributes.family = constants.CONTROL_COMMON_INPUTS;
        attributes.icon = 'pf-checkbox';
        attributes.factoryKey = 'control_checkbox';
        attributes.inlineEditable = true;
        attributes.selected = '';

        attributes.checked = '';
        attributes.silent = false;
        attributes.width = '77px';
        attributes.height = "18px";
        attributes.styleColorText ='~selectionTextColor';
        attributes.styleColorTextOver ='~selectionTextOverColor';
        attributes.fontFamily = '~selectionFont';
        attributes.fontSize = '~selectionFont';
        attributes.textWeight = '~selectionFont';
        attributes.textStyle  = '~selectionFont';
        attributes.borderColor = '~groupBorderColor';
        attributes.backgroundColor = '~selectionBgColor';
        attributes.advancedBgGradientColor = '~selectionBgGradientColor';
       	attributes.minWidth = 15;
        attributes.minHeight = 17;        
        sequenceService.tabIndexParentId = groupId;
        //adding silent(accessibility) to attributes.
        attributes.value =  '1';
        attributes.name = 'Checkbox 1';
        attributes.text = 'Check 1';
        //let pos2 = {top : 10, left : 10};
        attributes.pos = {top : 20, left : 10};
        attributes.top = attributes.pos.top;
        attributes.left = attributes.pos.left;
        attributes.tabIndex = sequenceService.nextTabIndex();
        attributes.transparentBackground = '~checkBgTransparent';
        attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"}
        ];

        const checkboxModel1 = new ControlModel( attributes );

        /*
        const checkboxView1 = new CheckboxControlView( {model: new ControlModel( attributes), el: $(constants.FORM_ID),
            pos: pos2, factoryKey: 'control_checkbox', id: id1} );
        checkboxView1.groupId = groupId;
*/

        attributes.value =  '2';
        attributes.name = 'Checkbox 2';
        attributes.text = 'Check 2';
        attributes.pos = {top : 60, left : 10};
        attributes.top = attributes.pos.top;
        attributes.left = attributes.pos.left;
        attributes.id = id2;
        attributes.tabIndex = sequenceService.nextTabIndex();
        attributes.transparentBackground = '~checkBgTransparent';

        const checkboxModel2 = new ControlModel( attributes );

        /*
        const checkboxView2 = new CheckboxControlView( {model: new ControlModel( attributes), el: $(constants.FORM_ID),
            pos: pos2, factoryKey: 'control_checkbox', id: id2} );
        checkboxView2.groupId = groupId;
        */

        attributes.value =  '3';
        attributes.name = 'Checkbox 3';
        attributes.text = 'Check 3';
        attributes.pos = {top : 100, left : 10};
        attributes.top = attributes.pos.top;
        attributes.left = attributes.pos.left;
        attributes.id = id3;
        attributes.tabIndex = sequenceService.nextTabIndex();
        attributes.transparentBackground = '~checkBgTransparent';

        const checkboxModel3 = new ControlModel( attributes );

        /*
        const checkboxView3 = new CheckboxControlView( {model: new ControlModel( attributes), el: $(constants.FORM_ID),
            pos: pos2, factoryKey: 'control_checkbox', id: id3} );
        checkboxView3.groupId = groupId;
        */

        // attributes for header
        attributes.icon = 'pf-checkbox-group';
        attributes.factoryKey = 'control_checkbox_group';
        attributes.name = 'Checkbox Group';
        attributes.titleColor ='~groupTextColor';
        attributes.titleFontFamily = '~groupFont';
        attributes.titleFontSize = '~groupFont';
        attributes.titleTextWeight = '~groupFont';
        attributes.titleTextStyle  = '~groupFont';
        attributes.showGroupHeader = 'hide';
        attributes.alignLeftSelection = 'lightgrey';
        attributes.alignCenterSelection = 'transparent';
        attributes.alignRightSelection = 'transparent';
        attributes.titleBackgroundColor = '~groupTitleBg';
        attributes.hasTitle = 'false';
        attributes.titleText = 'Group';
        attributes.titleHeight = '25';
        attributes.titleAlign ='left';
        // attributes for group
        attributes.borderStyle= '~groupBorder';
        attributes.borderSize= '~groupBorder';
        attributes.cornerRadius= '~groupBorder';
        attributes.borderColor = '~groupBorderColor';
        attributes.styleBGColorText = '~groupBgColor';
        attributes.bgImage = '~groupBgImage';
        attributes.transparentBackground = '~groupBgTransparent';
        attributes.backgroundImageAssetId = '~groupBgImage';
        attributes.titleBoldSelection = 'transparent';
        attributes.titleItalicSelection = 'transparent';
        attributes.groupBackgroundImageTag = '';
        attributes.groupBackgroundImageStyle = '';
        attributes.backgroundColor = '~groupBgColor';


        attributes.top = (listService.mainKind === constants.KIND_MOBILE || !pos) ? '' : pos.top;
        attributes.left = (listService.mainKind === constants.KIND_MOBILE || !pos) ? '' : pos.left;
        attributes.width = width;
        attributes.height = height;
        attributes.tabIndex = groupTabIndex;

        //attributes.childList = [checkboxView1, checkboxView2, checkboxView3];
        attributes.childList = [checkboxModel1, checkboxModel2, checkboxModel3];
        attributes.translateProps = [
            {key:"titleText", label:"Title Text"},
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new GroupControlView( { model: new GroupModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: groupId} );

        return view;
    }

}

const controlCheckboxGroupFactory = new ControlCheckboxGroupFactory();

export default controlCheckboxGroupFactory;
